var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"initialise-conditions text-center mt-5"},[_c('a-button',{staticClass:"btn-wrap",attrs:{"type":"primary"},on:{"click":_vm.initialiseConditions}},[_vm._v(" "+_vm._s(_vm.$t('face_control_activate_button_title'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }